import React from 'react';

interface Tab {
  label: string;
  value: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onUpdateActiveTab: (value: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs, activeTab, onUpdateActiveTab }) => {
  return (
    <div className="px-4 mb-6">
      <div className="flex gap-4">
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className="flex flex-col items-center gap-1 cursor-pointer"
            onClick={() => onUpdateActiveTab(tab.value)}
          >
            <span
              className={`text-sm font-medium transition-colors ${
                activeTab === tab.value ? 'text-[#5959EB]' : 'text-[#1F1F1F]'
              }`}
            >
              {tab.label}
            </span>
            {activeTab === tab.value && (
              <div className="w-[18px] h-1 bg-[#5959EB] rounded-full" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
